export const toastObject = function (el: any, instance: any) {
  return {
    el: el,
    remove: function () {
      instance.remove(el)
    }
  }
}